import userDeviceService from '../user/userDeviceService';

const CONNECTION_TYPES = {
    BLE: 0,
    USB: 1,
};

const setIsUsb = () => (connectionType = CONNECTION_TYPES.USB);
const setIsBle = () => (connectionType = CONNECTION_TYPES.BLE);
const isUsb = () => connectionType === CONNECTION_TYPES.USB;
const isBle = () => connectionType === CONNECTION_TYPES.BLE;
const isBleSupported = () => userDeviceService.isBluetoothSupported();
const isUsbSupported = () => userDeviceService.isUsbSupported();
const isBleAndUsbSupported = () => isUsbSupported() && isBleSupported();
const isBleOrUsbSupported = () => isUsbSupported() || isBleSupported();
const getConnectionTypeName = () => (isBle() ? 'BLE' : 'USBHID');

let connectionType = isUsbSupported() ? CONNECTION_TYPES.USB : CONNECTION_TYPES.BLE;

export default {
    getConnectionTypeName,
    isBle,
    isBleAndUsbSupported,
    isBleOrUsbSupported,
    isUsb,
    isUsbSupported,
    setIsBle,
    setIsUsb,
};
